import actionTypes from '../actions/users.action-types';

export const initialState = {
  items: [],
  isLoading: false,
  pagination: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        pagination: { ...action.pagination },
        items: [...action.content],
      };
    case actionTypes.FETCH_USERS_REQUEST:
    case actionTypes.FETCH_USERS_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/reducers/users.reducer.js